import React from "react";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import damasLogo from "src/assets/images/logo.png";
import moment from "moment";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 20,
    // backgroundColor: '#E4E4E4'
  },
  section: {
    marginLeft: 15,
    padding: 10,
    flexGrow: 1,
  },
  image: {
    width: 120,
    float: "left",
  },
  header: {
    flexDirection: "row",
    justifyContent: "flex-end",
    paddingTop: 10,
    paddingBottom: 10,
    borderTop: "1px solid #EEE",
  },
  dateText: {
    fontSize: 10,
  },

  table: {
    width: "100%",
    marginTop: 20,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    borderTop: "1px solid #EEE",
    paddingTop: 10,
    paddingBottom: 10,
  },
  bold: {
    fontWeight: 500,
  },
  headerText: {
    fontSize: 10,
  },
  rowText: {
    fontSize: 8,
  },

  col1: {
    width: 120,
  },
  col2: {
    width: 120,
  },
  col3: {
    width: 80,
  },
  col4: {
    width: 120,
  },
  col5: {
    width: 120,
  },
  col6: {
    width: 60,
  },
  col7: {
    width: 100,
  },
  col8: {
    width: 70,
  },
});

const PdfComponent = ({ data, filteredData }) => {
  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  });

  const filteredValues = filteredData.map((item) =>
    item.value == "driver" ? "Accepted" : item.value
  );
  const filteredValueString = filteredValues.join(", ");
  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <Text style={styles.dateText}>Report generated on {currentDate}</Text>
      </View>

      <View style={styles.section}>
        <Image style={styles.image} src={damasLogo} />
        <Text>Booking Order Report:</Text>
        <Text>
          {filteredData && `Filtered by ${filteredValueString}`} Total{" "}
          {data.length} entries
        </Text>
        {/* <View
          style={{
            border: "1px solid rgba(0,0,0,0.5)",
          }}
        >
          <View style={{ flexDirection: "row", marginTop: 10 }}>
            <Text style={{ width: 120, fontSize: 11 }}>Booking Order ID</Text>
            <Text style={{ width: 120, fontSize: 11 }}>Transfer Order No.</Text>
            <Text style={{ width: 60, fontSize: 11 }}>Seal Bag</Text>
            <Text style={{ width: 140, fontSize: 11 }}>From Location</Text>
            <Text style={{ width: 140, fontSize: 11 }}>To Location</Text>
            <Text style={{ width: 50, fontSize: 11 }}>Route</Text>
            <Text style={{ width: 50, fontSize: 11 }}>Status</Text>
          </View>
          {data.map((item, index) => (
            <View key={index} style={{ flexDirection: "row", marginTop: 3 }}>
              <Text style={{ width: 120, fontSize: 9 }}>
                {item.bookingOrderId}
              </Text>
              <Text style={{ width: 120, fontSize: 9 }}>
                {item.transferOrderNo}
              </Text>
              <Text style={{ width: 60, fontSize: 9 }}>{item.sealBag}</Text>
              <Text style={{ width: 140, fontSize: 9 }}>
                {item.fromLocation}
              </Text>
              <Text style={{ width: 140, fontSize: 9 }}>{item.toLocation}</Text>
              <Text style={{ width: 50, fontSize: 9 }}>{item.tripRoute}</Text>
              <Text style={{ width: 50, fontSize: 9 }}>
                {item.status === "cvit" ? "CDT" : item.status}
              </Text>
            </View>
          ))}
        </View> */}

        <View style={styles.table}>
          <View style={[styles.row, styles.bold, styles.header]}>
            <Text style={[styles.col1, styles.headerText]}>
              Booking Order ID
            </Text>
            <Text style={[styles.col2, styles.headerText]}>
              Transfer Order No.
            </Text>
            <Text style={[styles.col3, styles.headerText]}>Seal Bag</Text>
            <Text style={[styles.col4, styles.headerText]}>From Location</Text>
            <Text style={[styles.col5, styles.headerText]}>To Location</Text>
            <Text style={[styles.col6, styles.headerText]}>Route</Text>
            <Text style={[styles.col7, styles.headerText]}>Delivered</Text>
            <Text style={[styles.col8, styles.headerText]}>Status</Text>
          </View>
          {data.map((item, index) => (
            <View key={index} style={styles.row} wrap={false}>
              <Text style={[styles.col1, styles.rowText]}>
                {item.bookingOrderId}
              </Text>
              <Text style={[styles.col2, styles.rowText]}>
                {item.transferOrderNo}
              </Text>
              <Text style={[styles.col3, styles.rowText]}>
                {item.sealBag?.serialNo}
              </Text>
              <Text style={[styles.col4, styles.rowText]}>
                {item.fromLocation?.name}
              </Text>
              <Text style={[styles.col5, styles.rowText]}>
                {item.toLocation?.name}
              </Text>
              <Text style={[styles.col6, styles.rowText]}>
                {item?.tripRoute?.name}
              </Text>
              <Text style={[styles.col7, styles.rowText]}>
                {item.deliveredAt
                  ? moment(item.deliveredAt).format("DD/MM/YYYY hh:mm A")
                  : ""}
              </Text>
              <Text style={[styles.col8, styles.rowText]}>
                {item.status === "cvit"
                  ? "CDT"
                  : item.status === "driver"
                  ? "Accepted"
                  : item.status}
              </Text>
            </View>
          ))}
        </View>
      </View>
    </Page>
  );
};

export default PdfComponent;

// import React from "react";
// import {
//   PDFDownloadLink,
//   Document,
//   Page,
//   Text,
//   View,
//   StyleSheet,
//   Image,
// } from "@react-pdf/renderer";
// import damasLogo from "src/assets/images/logo.png";

// // Create styles
// const styles = StyleSheet.create({
//   page: {
//     flexDirection: "column",
//     padding: 10,
//   },
//   section: {
//     marginLeft: 15,
//     padding: 10,
//     flexGrow: 1,
//   },
//   image: {
//     width: 120,
//     marginBottom: 10,
//   },
//   header: {
//     flexDirection: "row",
//     justifyContent: "flex-end",
//     padding: 10,
//   },
//   dateText: {
//     fontSize: 10,
//   },
//   title: {
//     fontSize: 14,
//     marginBottom: 10,
//   },
//   table: {
//     display: "table",
//     width: "auto",
//     borderStyle: "solid",
//     borderWidth: 1,
//     borderRightWidth: 0,
//     borderBottomWidth: 0,
//   },
//   tableRow: {
//     margin: "auto",
//     flexDirection: "row",
//   },
//   tableColHeader: {
//     width: "14.28%",
//     borderStyle: "solid",
//     borderWidth: 1,
//     borderLeftWidth: 0,
//     borderTopWidth: 0,
//     padding: 5,
//   },
//   tableCol: {
//     width: "14.28%",
//     borderStyle: "solid",
//     borderWidth: 1,
//     borderLeftWidth: 0,
//     borderTopWidth: 0,
//     padding: 5,
//   },
//   tableCellHeader: {
//     margin: "auto",
//     fontSize: 10,
//     fontWeight: "bold",
//   },
//   tableCell: {
//     margin: "auto",
//     fontSize: 9,
//   },
// });

// const PdfComponent = ({ data, filteredData }) => {
//   const currentDate = new Date().toLocaleDateString("en-US", {
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//     hour: "numeric",
//     minute: "numeric",
//     second: "numeric",
//     hour12: true,
//   });

//   const filteredValues = filteredData.map((item) => item.value);
//   const filteredValueString = filteredValues.join(", ");

//   return (
//     <Page size="A4" style={styles.page}>
//       <View style={styles.header}>
//         <Text style={styles.dateText}>Report generated on {currentDate}</Text>
//       </View>

//       <View style={styles.section}>
//         <Image style={styles.image} src={damasLogo} />
//         <Text style={styles.title}>
//           Booking Order Report:{" "}
//           {filteredData && `Filtered by ${filteredValueString}`} Total{" "}
//           {data.length} entries
//         </Text>

//         <View style={styles.table}>
//           {/* Table Header */}
//           <View style={styles.tableRow}>
//             <View style={styles.tableColHeader}>
//               <Text style={styles.tableCellHeader}>Booking Order ID</Text>
//             </View>
//             <View style={styles.tableColHeader}>
//               <Text style={styles.tableCellHeader}>Transfer Order No.</Text>
//             </View>
//             <View style={styles.tableColHeader}>
//               <Text style={styles.tableCellHeader}>Seal Bag</Text>
//             </View>
//             <View style={styles.tableColHeader}>
//               <Text style={styles.tableCellHeader}>From Location</Text>
//             </View>
//             <View style={styles.tableColHeader}>
//               <Text style={styles.tableCellHeader}>To Location</Text>
//             </View>
//             <View style={styles.tableColHeader}>
//               <Text style={styles.tableCellHeader}>Route</Text>
//             </View>
//             <View style={styles.tableColHeader}>
//               <Text style={styles.tableCellHeader}>Status</Text>
//             </View>
//           </View>

//           {/* Table Body */}
//           {data.map((item, index) => (
//             <View key={index} style={styles.tableRow}>
//               <View style={styles.tableCol}>
//                 <Text style={[styles.col1, styles.rowText]}>{item.bookingOrderId}</Text>
//               </View>
//               <View style={styles.tableCol}>
//                 <Text style={[styles.col1, styles.rowText]}>{item.transferOrderNo}</Text>
//               </View>
//               <View style={styles.tableCol}>
//                 <Text style={[styles.col1, styles.rowText]}>{item.sealBag}</Text>
//               </View>
//               <View style={styles.tableCol}>
//                 <Text style={[styles.col1, styles.rowText]}>{item.fromLocation}</Text>
//               </View>
//               <View style={styles.tableCol}>
//                 <Text style={[styles.col1, styles.rowText]}>{item.toLocation}</Text>
//               </View>
//               <View style={styles.tableCol}>
//                 <Text style={[styles.col1, styles.rowText]}>{item.tripRoute}</Text>
//               </View>
//               <View style={styles.tableCol}>
//                 <Text style={[styles.col1, styles.rowText]}>
//                   {item.status === "cvit" ? "CDT" : item.status}
//                 </Text>
//               </View>
//             </View>
//           ))}
//         </View>
//       </View>
//     </Page>
//   );
// };

// export default PdfComponent;
